import React from 'react';
import { Box, Typography } from '@mui/material';
import { RAISED_CARD_SX } from '../shared/designKit';

// Shared mobile card scaffolding for the reminder list views. Follows the house
// pattern (StorageLocationsPage): DataTable hides itself below `lg`, and these
// cards take over. Same card shape as the desktop views (designKit).

export function MobileListContainer({ children, testId }) {
  return (
    <Box sx={{ display: { xs: 'block', lg: 'none' } }} data-testid={testId}>
      {children}
    </Box>
  );
}

export function MobileCard({ children, onClick, testId }) {
  return (
    <Box
      onClick={onClick}
      data-testid={testId}
      sx={{
        ...RAISED_CARD_SX,
        p: 2,
        mb: 1.5,
        ...(onClick && {
          cursor: 'pointer',
          transition: 'background-color 0.15s ease',
          '&:hover': { bgcolor: 'background.default' },
        }),
      }}
    >
      {children}
    </Box>
  );
}

export function MobileEmptyState({ icon, title, description }) {
  return (
    <Box sx={{ ...RAISED_CARD_SX, p: 4, textAlign: 'center' }}>
      {icon}
      <Typography sx={{ fontWeight: 600, mb: 0.5 }}>{title}</Typography>
      {description && (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      )}
    </Box>
  );
}
